'use client';

import { AutoScroll, useEmblaCarousel } from '@/libs';
import type { CustomerWinnersFeedResponse } from '@/types/models';

import { LastWinnerCard } from './components';
import { getTopPrizeIndex, getWinnerKey, isMainPrize, type Winner } from './utils';

import { LottieAnimation } from '../ui/Animations';

export const LastWinnersCarousel = ({
  data: winners,
  ...props
}: CustomerWinnersFeedResponse & { 'data-cy'?: string }) => {
  const [emblaRef] = useEmblaCarousel({ loop: true, align: 'start' }, [
    AutoScroll({ playOnInit: true, stopOnInteraction: false, speed: 1 }),
  ]);

  if (winners.length === 0) {
    return null;
  }

  const topPrizeIndex = getTopPrizeIndex(winners);

  return (
    <section
      data-cy={props['data-cy'] || 'last-winners-carousel'}
      className="flex w-full h-[100px] gap-1"
    >
      <div className="flex flex-col-reverse items-center h-[86px] relative">
        <LottieAnimation
          src="/animations/trophy.json"
          loop
          className="absolute -top-3 w-full"
        />

        <p className="font-bold text-2xs text-center leading-[9px]">ÚLTIMOS GANHADORES</p>
      </div>

      <div className="w-full ml-auto overflow-hidden" ref={emblaRef}>
        <div className="flex w-full">
          {winners.map((winner: Winner, index: number) => (
            <div key={getWinnerKey(winner, index)} className="px-2 md:pl-0">
              <LastWinnerCard
                data-cy={
                  isMainPrize(winner)
                    ? 'last-winners-carousel-main-prize-card'
                    : 'last-winners-carousel-card'
                }
                variant={isMainPrize(winner) ? 'mainPrize' : 'default'}
                highlighted={index === topPrizeIndex}
                date={winner.date}
                value={winner.value}
                name={winner.userSocialName || winner.userName}
                state={winner.userPhone ?? ''}
                winnerVideoUrl={winner.winnerVideoUrl}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
